"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = require("react");
var Humburger = function () {
    var _a = (0, react_1.useState)(false), isOpen = _a[0], setIsOpen = _a[1];
    var navigation = (0, react_1.useRef)(document.getElementById("navigation"));
    (0, react_1.useEffect)(function () {
        var el = document.getElementById("navigation");
        if (el)
            navigation.current = el;
    }, []);
    (0, react_1.useEffect)(function () {
        if (navigation.current) {
            (isOpen)
                ? navigation.current.style.setProperty("display", "flex", "important")
                : navigation.current.style.setProperty("display", "flex");
            navigation.current.style.setProperty("top", navigation.current.getAttribute('data-top-offset'));
        }
    }, [isOpen]);
    return (react_1.default.createElement(react_2.Fragment, null,
        react_1.default.createElement("div", { onClick: function () { setIsOpen(function (value) { return !value; }); }, className: "humburger" }, isOpen
            ? react_1.default.createElement("img", { src: "/images/app/icons8_minus_44.svg" })
            : react_1.default.createElement("img", { src: "/images/app/menu.svg", alt: "humburger", style: { width: "24px", height: "24px" } }))));
};
exports.default = Humburger;
